<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="stateBiosecurityEmailForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                stateBiosecurityEmailForm: () => import('../forms/StateBiosecurityEmailForm'),
                headers: [
                    { text: 'Email Address', value: 'emailAddress' },
                    { text: 'Australian State', value: 'australianState', format: this.formatEnum },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    items: []
                },
                sorting: [
                    { column: "emailAddress", direction: "ascending" },
                ],
                itemsField: 'stateBiosecurityEmails',
                editPageName: 'stateBiosecurityEmail',
                apiMethod: 'StateBiosecurityEmails',
                claimName: 'StateBiosecurityEmails',
                formTitle: 'State Biosecurity Email',
                excelTitle: 'State Biosecurity Emails',
                hasEditPage: false,
            }
        },
    };
</script>
